import { wrapGql } from "../_"
import type { EvaluationFields } from "@/types/api/evaluations"

export default (a: NuxtAxiosInstance) => ({
  listContestApplication: ({
    page,
    filters,
    sorters,
  }: {
    page?: number
    filters?: any[]
    sorters?: any[]
  } = {}) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query (
          $page: Int
          $filters: [Filter]
          $sorters: [Sorter]
        ) {
          listContestApplication (
            page: $page
            filters: $filters
            sorters: $sorters
          ) {
            items {
              id
              creationTime
              author {
                id
              }
              state
              stage {
                id
                title {
                  current
                }
                form {
                  schema
                }
              }
              data
              evaluation {
                id
                state
                author {
                  id
                }
                fields {
                  field
                  value
                }
                sum
              }
              reviewer {
                id
                firstName {
                  current
                }
                lastName {
                  current
                }
                patronymic {
                  current
                }
                email
              }
            }
            pagination {
              pages
            }
          }
        }
      `,

      variables: {
        page,
        filters,
        sorters,
      },
    }),
  ),

  reviewContestApplication: (application: string) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        mutation (
          $application: UUID!
        ) {
          reviewContestApplication (
            application: $application
          )
        }
      `,

      variables: {
        application,
      },
    }),
  ),

  createContestApplicationEvaluation: (
    application: string,
    fields: EvaluationFields,
    draft: boolean,
  ) =>
    wrapGql(
      a.$post("/graphql", {
        query: /* gql */ `
          mutation (
            $application: UUID!
            $fields: [InputContestApplicationEvaluatedField!]!
            $draft: Boolean!
          ) {
            createContestApplicationEvaluation (
              application: $application
              fields: $fields
              draft: $draft
            )
          }
        `,

        variables: {
          application,
          fields,
          draft,
        },
      }),
    ),

  updateContestApplicationEvaluation: (
    evaluation: string,
    fields: EvaluationFields,
  ) =>
    wrapGql(
      a.$post("/graphql", {
        query: /* gql */ `
          mutation (
            $evaluation: UUID!
            $fields: [InputContestApplicationEvaluatedField!]!
          ) {
            updateContestApplicationEvaluation (
              evaluation: $evaluation
              fields: $fields
              draft: $draft
            )
          }
        `,

        variables: {
          evaluation,
          fields,
        },
      }),
    ),

  updateEventParticipationRecommendationByPartner: (
    variables: Record<string, any>,
  ) =>
    wrapGql(
      a.$post("/graphql", {
        query: /* gql */ `
          mutation (
            $participation: UUID
            $recommendedByPartnerDkk: Boolean
            $reservedByPartnerDkk: Boolean
            $contestMark: Int
            $partnerCommentDkk: String = null
          ) {
            updateEventParticipationRecommendationByPartner(
              participation: $participation
              recommendedByPartnerDkk: $recommendedByPartnerDkk
              reservedByPartnerDkk: $reservedByPartnerDkk
              contestMark: $contestMark
              partnerCommentDkk: $partnerCommentDkk
            )
          }
        `,
        variables,
      }),
    ),

  updateEventParticipationRecommendationByRegion: (
    variables: Record<string, any>,
  ) =>
    wrapGql(
      a.$post("/graphql", {
        query: /* gql */ `
          mutation (
            $participation: UUID
            $recommendedByRegion: Boolean
            $reservedByRegion: Boolean
            $recommendedByInternationalBlock: Boolean
            $recommendedByMkd: Boolean
            $contestMark: Int
            $regionComment: String = null
          ) {
            updateEventParticipationRecommendationByRegion(
              participation: $participation
              recommendedByRegion: $recommendedByRegion
              reservedByRegion: $reservedByRegion
              recommendedByInternationalBlock: $recommendedByInternationalBlock
              recommendedByMkd: $recommendedByMkd
              contestMark: $contestMark
              regionComment: $regionComment
            )
          }
        `,
        variables,
      }),
    ),
})
